/* eslint-disable react/require-default-props */
import React from 'react';
import { Card } from './styles';

interface AiManagementProcessingCardProps {
  className?: string;
  children: React.ReactNode;
}

const AiManagementProcessingCard: React.FC<AiManagementProcessingCardProps> = ({
  className = '',
  children,
}) => (
  <Card className={`border text-center px-4 py-5 ${className}`} role="status" aria-live="polite">
    <i className="material-icons-outlined processing-icon mb-3" aria-hidden>
      timer
    </i>
    <div className="processing-text font-weight-bold mx-auto">{children}</div>
  </Card>
);

export default AiManagementProcessingCard;
